var render, staticRenderFns
import script from "./MediaQuery.vue?vue&type=script&lang=js&"
export * from "./MediaQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MediaQuery.vue"
export default component.exports